import { Button, Space } from 'antd'
import { LinksSpaceCIMSBasicFieldProps } from './types'
import { alphabeticalCompare } from 'shared'
import { getDeepestString } from 'utils/getReactNodeLength'
import { useKeyedBooleans } from 'hooks/useKeyedBooleans'
import ProjectLink from '../../../../../ProjectLink'
import CIMSLink from '../../../../../CIMSLink'
import CIMSBadge from '../../../../../CIMSBadge'

const ShowMoreSpace: React.FC<LinksSpaceCIMSBasicFieldProps> = ({
  links,
  showMore,
  sort,
  label,
}) => {
  const SPLICE = 9
  const [visible, { add, remove }] = useKeyedBooleans()
  if (sort !== false)
    links.sort((a, b) =>
      alphabeticalCompare(getDeepestString(a.label), getDeepestString(b.label))
    )
  const items = links.map((link) => {
    if (link.type === 'deep') {
      const { label: linkLabel, type: _, page, ...rest } = link
      return (
        <ProjectLink
          key={`${getDeepestString(label)}-${getDeepestString(linkLabel)}`}
          {...rest}
          item={page}
        >
          {linkLabel}
        </ProjectLink>
      )
    } else if (link.type === 'external') {
      const { label: linkLabel, type: _, ...rest } = link
      return (
        <CIMSLink
          key={`${getDeepestString(label)}-${getDeepestString(linkLabel)}`}
          external
          {...rest}
        >
          {linkLabel}
        </CIMSLink>
      )
    }
    return null
  })
  const first = items.splice(0, SPLICE)
  let children
  if (showMore) {
    const { key, overflowCount } = showMore
    if (!items.length) children = first
    else
      children = (
        <>
          {first}
          {visible(key) ? (
            <>
              {items}
              <Button onClick={() => remove(key)}>Hide</Button>
            </>
          ) : (
            <Button onClick={() => add(key)}>
              <CIMSBadge
                overflowCount={overflowCount ?? Infinity}
                count={items.length}
              >
                More
              </CIMSBadge>
            </Button>
          )}
        </>
      )
  } else children = [...first, ...items]
  return (
    <Space size="middle" wrap>
      {children}
    </Space>
  )
}

export default ShowMoreSpace
